import ConfidenceLevelIcon from "@/components/controls/ConfidenceLevelIcon";
import TextField from "@/components/layouts/History/TextField";
import { DealConfidenceLevel } from "@/pages/deals/types";
import { getEnumTKey } from "@/utils/strings";
import { useTranslation } from "react-i18next";

interface Props {
  value: string;
}

const AEConfidenceLevel: React.FC<Props> = ({ value }) => {
  const { t } = useTranslation();
  return (
    <div className="flex gap-1 items-center">
      <ConfidenceLevelIcon value={Number(value)} />
      <TextField>
        {t(getEnumTKey("deals", "levels", DealConfidenceLevel, Number(value)))}
      </TextField>
    </div>
  );
};

export default AEConfidenceLevel;
